import { Injectable } from '@angular/core';
import { CanLoad, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AccountService } from '../services/account.service';

@Injectable()
export class AdminGuard implements CanLoad {
  constructor(private router: Router, private accountService: AccountService) {}
  public canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    return this.accountService.account$.pipe(
      map(account => {
        if (!account.userId) {
          this.router.navigate(['']);
        } else if (!account.isAdmin) {
          this.router.navigate(['/error', '403']);
        }
        return account.isAdmin;
      }),
      take(1)
    );
  }
}
